export default "__VITE_ASSET__CIBVk6hg__"